import styled, { withTheme } from 'styled-components'
// import typography from '../../../utils/typography'

const SearchResults = styled.div`
  position: relative;
  background-color: white;
  width: 100%;
  max-width: ${(props) => props.theme.content.max.width};
  margin: 0 auto;
  a {
    text-decoration: none;
  }
`

export default withTheme(SearchResults)
